<template>
    <router-link
        v-if="el === 'router-link'"
        class="CloseLink"
        :to="to"
        @click.native="onClick"
    >
        <span class="CloseLink-bar"></span>
        <span class="CloseLink-bar"></span>
    </router-link>
    <component
        v-else
        class="CloseLink"
        :is="el"
        @click="onClick"
    >
        <span class="CloseLink-bar"></span>
        <span class="CloseLink-bar"></span>
    </component>
</template>

<script>
export default {
    name: 'CloseLink',
    props: {
        el: {
            type: String,
            default: 'router-link'
        },
        to: {
            type: Object,
        },
    },
    methods: {
        onClick() {
            this.$emit('close')
        },
    },
}
</script>

<style src="styles/components/CloseLink.styl" lang="stylus"></style>



// WEBPACK FOOTER //
// src/app/components/CloseLink.vue